(function() {
    'use strict';
    const logger = require('od-modules/utils/logger');
    const trackingUtils = require('../modules/utils/tracking.utils');
    const tagManagement = require('../modules/utils/tag_management.utils');
    const ConfirmationHandler = require('../modules/confirm/response_handler');
    const loginFactory = require('components/user_area/login/js/main');
    const paymentButtonFactory = require('components/payment/payment_button/js/main');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');
    const paymentButtonAttachment = require('components/payment/payment_button/js/utils/attachment.storage');
    const trackingPageFlowUtils = require('../modules/utils/flow_tracking/tracking.page.flow.utils');
    const isDynpack = Odigeo.Utils.isRequestApp('dp');
    let eventCategory = isDynpack ? 'dynpack_confirmation_page' : 'flights_confirmation_page';
    const handler3DS = require('../modules/3ds/index').default;
    const vinFlightsTracking = require('../tracking/vin_tracking');
    const {getStore} = require( 'od-modules/secure_store/store');
    const {isPrimeAccount} = require('od-modules/utils/membership_utils');

    Odigeo.Router.handlers.confirmation = function() {
        window.onbeforeunload = null;
        window.onpopstate = null;
        const page = 'confirmation';
        const $confirm = $('#confirmation');
        const lastPage = Odigeo.Session.get('page');
        const lastRoute = JSON.parse(Odigeo.Session.get('lastRouteChange'));
        const $waitingPage = $('.waiting_page');
        const $priceBreakDownContainer = $('.price_breakdown_payments_container');
        const loadingPage = Odigeo.UIElements.enhanceLoading($waitingPage);
        const isFromPaymentToConfirmation = !Odigeo._.isNull(lastRoute) && lastRoute.from.name === 'payment' && lastRoute.to.name === 'confirmation';
        const widgets = Odigeo.autoloadWidgets({
            dpWaitingPage: ['dpwaiting-page', 'dp_waiting_page'],
            accommodationDetails: ['accommodation-details', 'accommodation_details'],
        });
        const $mainContainer = $('.home_main_layout');
        const appName = isDynpack ? '_DYNPACK_' : '_FLIGHTS_';
        const asyncWidgets = Odigeo.autoloadWidgetsAsync({
            getConfirmationManager: ['confirmation-manager', 'confirmation_manager'],
            getUsersManager: ['users-manager', 'usersmanager'],
        });
        const widgetLoader = createWidgetLoader({
            login: ['login-header', loginFactory],
            paymentButton: ['payment-button', paymentButtonFactory],
        });

        const confirmaHandlerResp = new ConfirmationHandler($confirm, widgetLoader, appName);

        if (!Odigeo._.isNull(lastRoute) || lastPage !== 'confirmation') {
            Odigeo.Session.set('confirmationReloaded', false);
        }
        Odigeo.Session.set('page', page);

        const DeepLinkController = require('../modules/controllers/deeplink_details_controller');
        const AccommodationsDeeplinkController = require('../modules/controllers/deeplink_accommodations_controller');
        const deepLinkToDetailsController = Odigeo.AB.confirmationMytripsAutomaticRedirection === 3 ?
            new DeepLinkController(isDynpack, widgetLoader, {name: 'waitingPage', waitingController: loadingPage}):
            new DeepLinkController(isDynpack, widgetLoader, {name: 'dialog'});
        const automaticRedirectionStates = deepLinkToDetailsController.automaticRedirectionStates;

        if (isDynpack) {
            widgets.dpWaitingPage().execute('activate');
        } else if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
            loadingPage.showLoading(['waiting_post_booking_accommodation_confirmation']);
        } else {
            loadingPage
                .showLoading(['waiting_processing_booking', 'waiting_bottom', 'waiting_confirmation', 'waiting_bottom_gradient']);
        }

        const enhanceServiceOptionsDetailsList = function() {
            const $serviceOptionsDetailsListItems = $('#confirmation').find('.serviceoptions_confirmation_details li');
            Odigeo._.each($serviceOptionsDetailsListItems, function(detail) {
                Odigeo.UIElements.hint.enhance('confirmation', $(detail).find('div'), {
                    generateHtml: true,
                    wrapperClass: 'od-service-options-hint od-hint-notitle so_detail_hint',
                    hintTriggerButton: {
                        hintTriggerButtonClass: 'od-service-options-hint-btn',
                        hintTriggerButtonText: '9',
                    },
                    events: {hover: false, tap: true},
                });
            });
        };

        const navigateToPayment = function(params) {
            if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
                Odigeo.Router.navigate('pbpayment', params);
            } else {
                Odigeo.Router.navigate('payment', params);
            }
        };

        const goBackToPayment = function() {
            Odigeo.requireWidget('payment-manager', 'paymentmanager', function(widget) {
                widget.execute('setManualPaymentRetry', true);
                Odigeo._.defer(navigateToPayment);
            });
        };

        const getTripType = function(segments) {
            const sameOriginAndDestination = segments.length === 2 &&
                segments[0].departureLocation.geoNodeId === segments[1].arrivalLocation.geoNodeId;
            let tripType;
            if (segments.length === 1) {
                tripType = 'ONE_WAY';
            } else if (sameOriginAndDestination) {
                tripType = 'ROUND_TRIP';
            } else {
                tripType = 'MULTIPLE_DESTINATIONS';
            }
            return tripType;
        };

        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
            Odigeo.Router.handlers.errorManagerEventController, Odigeo.Router.handlers.globalEventController, {
                // Global events will remain bound in any part of the application
                globalEvents: {},
                // View or local events which are triggered from this view.
                // They will be unbinded when the view changes.
                viewEvents: {
                    'payment-manager:confirmationReady': 'onConfirmationReady',
                    'payment-manager:confirmError': 'onConfirmationError',
                    'payment-manager:confirmationAccommodationPostBookingReady': 'onConfirmAccommodationPostBookingReady',
                    'confirmation-manager:userInteractionNeeded': 'onUserInteractionNeeded',
                    'confirmation-manager:bookingConfirmedLoaded': 'onBookingConfirmedLoaded',
                    'confirmation-manager:bookingPaymentRetryLoaded': 'onBookingPaymentRetryLoaded',
                    'confirmation-manager:bookingRejectedLoaded': 'onBookingRejectedLoaded',
                    'confirmation-manager:bookingNegativeFeeLoaded': 'onBookingNegativeFeeLoaded',
                    'confirmation:cancelPayment': 'onCancelPayment',
                    'confirmation:buyFlightBtn': 'onBuyFlightBtn',
                    'confirmation-manager:bookingRepricingLoaded': 'onBookingRepricingLoaded',
                    'flight-details-confirmation:toggleDetails': 'onDpToggleAccommodationDetails',
                    'confirmation-manager:confirmationPageSuccessfully': 'onConfirmationPageSuccessfully',
                    'confirmation-manager:confirmationPageUnsuccessfully': 'onConfirmationPageUnsuccessfully',
                    'dpwaiting-page:cleanDpWaitingPage': 'cleaningDpWaitingPage',
                    'confirmation-widget:hotelsSearchCompletedSuccessfully': 'onHotelsSearchCompletedSuccessfully',
                    'confirmation-widget:hotelsSearchFailed': 'onHotelsSearchFailed',
                    'confirmation-manager:goToMyTrips': 'onGoToMyTrips',
                    'confirmation-manager:goToMyTripsDetails': 'requestBookingDetails',
                    // TODO: Decouple logic from login widget!
                    'login-header:navigateToMyTrips': 'navigateToMyTrips',
                    'login-header:navigateToTripDetails': 'navigateToTripDetails',
                    // End coupling
                    'users-manager:getTripOk': 'goToMyTripsDetails',
                    'users-manager:getTripWithError': 'catchGetTripError',
                    'users-manager:getTripError': 'catchGetTripError',
                },

                confirmationData: {},

                // implementation of events handlers
                eventHandlers: {
                    helpers: {
                        showAdvertisementListGpt: function() {
                            const advertisementListGpt = $('#confirmation').find('.advertisement_gpt');
                            if (advertisementListGpt.length > 0) {
                                Odigeo._.each(advertisementListGpt, function(el) {
                                    $(el).removeClass('hidden').show();
                                });
                                Odigeo.UIElements.enhanceAdvertisementGpt(advertisementListGpt, true, true, true);
                            }
                        },
                    },

                    goToMyTripsDetails: function(data) {
                        this.hideWaitings();
                        if (deepLinkToDetailsController.automaticRedirectionStatus === automaticRedirectionStates.INIT) {
                            deepLinkToDetailsController.automaticRedirectionStatus = automaticRedirectionStates.SUCCESSFUL;
                            const bookingId = data.bookingDetailDTO.bookingBasicInfo.id;
                            Odigeo.Session.set('isRedirectionFromConfirmation', bookingId);
                            trackingUtils.stopMetric('LOAD_CONFIRM_DESKTOP');
                        }
                        deepLinkToDetailsController.goToMyTripsDetails(data.bookingDetailDTO);
                    },

                    catchGetTripError: function() {
                        this.hideWaitings();
                        if (deepLinkToDetailsController.automaticRedirectionStatus === automaticRedirectionStates.INIT) {
                            deepLinkToDetailsController.catchAutomaticRedirectionError();
                            asyncWidgets.getConfirmationManager().execute('renderConfirmationWhenBookingApiError', this.confirmationData);
                        } else {
                            deepLinkToDetailsController.catchGetTripError();
                        }
                    },

                    onGoToMyTrips: function() {
                        widgetLoader.get('login').execute('goToMyTrips');
                    },

                    navigateToMyTrips: function() {
                        Odigeo.Router.navigate('mytrips');
                    },

                    navigateToTripDetails: function() {
                        Odigeo.Router.navigate('tripdetails');
                    },

                    /**
                     * Tries to perform a redirection either to accommodations or mytrips
                     * @param {Object} confirmationData - An object containing the parameters for the request.
                     * @return {Promise<boolean>} whether the redirection has been initiated or not.
                     */
                    initiateAutomaticRedirection: async function(confirmationData) {
                        // Accommodation postbooking redirection tries to be as safe as possible, so if there is an error
                        // while trying to redirect to accommodations postbooking, we will continue with the other flows.
                        if (this.shouldRedirectToAccommodations(confirmationData)) {
                            try {
                                const bookingId = confirmationData.myTrip.bookingId;
                                const email = confirmationData.myTrip.buyer.mail;
                                if (bookingId !== undefined && email !== undefined) {
                                    const accommodationsDeeplinkController = new AccommodationsDeeplinkController();
                                    await accommodationsDeeplinkController.goToAccommodationsPostBooking(bookingId, email);
                                    return true;
                                }
                            } catch (e) {
                                // If there is an error while trying to redirect to accommodations postbooking,
                                // we will continue trying with the redirection to mytrips
                                logger.error(e, 'Error while trying to redirect to accommodations postbooking');
                            }
                        }

                        if (this.shouldRedirectToMyTrips(confirmationData)) {
                            deepLinkToDetailsController.automaticRedirectionStatus = automaticRedirectionStates.INIT;
                            deepLinkToDetailsController.requestBookingDetailsWithConfirmationdata(asyncWidgets.getUsersManager, confirmationData);
                            this.confirmationData = confirmationData;
                            return true;
                        }

                        return false;
                    },

                    requestBookingDetails: function() {
                        deepLinkToDetailsController.requestBookingDetails(asyncWidgets.getUsersManager);
                    },

                    trackEcommerceAndPageview: function(ecommerceData) {
                        trackingUtils.trackPage('confirmation', {
                            funnel: true,
                            eCommerce: ecommerceData,
                        });
                    },

                    confirmationReadyTrackings: function(confirmationData) {
                        let ecommerceData;
                        let transaction;
                        const myTrip = confirmationData.myTrip;
                        const accommodationBookingInfo = Odigeo._.isObject(myTrip) ? myTrip.accommodationBooking : null;
                        const accommodationBookingStatus = Odigeo._.isObject(accommodationBookingInfo)
                            ? accommodationBookingInfo.bookingStatus
                            : null;
                        const accommodationBookingStatusUnknown = accommodationBookingStatus === 'UNKNOWN';
                        const accommodationPending = confirmationData.bookingstatus === 'BOOKING_CONFIRMED' && accommodationBookingStatusUnknown;

                        // Analytics tracking
                        if (Odigeo._.includes(['BOOKING_CONFIRMED', 'BOOKING_RETAINED', 'BOOKING_PENDING'], confirmationData.bookingstatus)) {
                            ecommerceData = confirmationData.analyticsEcommerce;
                            tagManagement.updateDatalayer(confirmationData.tmsDatalayer);
                            this.trackEcommerceAndPageview(ecommerceData);

                            transaction = ecommerceData.transaction;
                            Odigeo.UIElements.advertisementSpotlightConfirmation({
                                quantity: ecommerceData.items ? ecommerceData.items.length : 0,
                                cost: !Odigeo._.isUndefined(transaction.total) ? transaction.total : 0,
                                orderId: !Odigeo._.isUndefined(transaction.orderId) ? transaction.orderId : '',
                            });
                        }
                        // event tracking
                        if (confirmationData.bookingstatus === 'BOOKING_CONFIRMED' && !accommodationBookingStatusUnknown) {
                            trackingUtils.trackEventWithCategory('flights_confirmation_page_confirmed', 'booking_status', 'confirmed_booking');
                        } else if (confirmationData.bookingstatus === 'BOOKING_PENDING' || accommodationPending) {
                            trackingUtils.trackEventWithCategory('flights_confirmation_page_pending', 'booking_status', 'pending_booking');
                        }
                        Odigeo.Session.set('bookingId', '');
                    },

                    isNotBankTransfer: function(data) {
                        return Odigeo._.isNull(data.myTrip) || !data.myTrip.bankTransfer;
                    },

                    shouldRedirectToMyTrips: function(data) {
                        return Odigeo.AB.confirmationMytripsAutomaticRedirection === 3
                        && !Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))
                        && Odigeo._.includes(['BOOKING_CONFIRMED', 'BOOKING_PENDING'], data.bookingstatus)
                        && this.isNotBankTransfer(data);
                    },

                    shouldRedirectToAccommodations: function(data) {
                        const isMultidestinationTrip = function(data) {
                            return getTripType(data.myTrip.itineraries[0].segments) === 'MULTIPLE_DESTINATIONS';
                        };
                        const userStatus = getStore().prime?.userStatus;
                        const isPrimeStatus = isPrimeAccount(userStatus);
                        const isSubscriptionAdded = getStore().prime?.primeMemberSelected?.isSubscriptionAdded;
                        const isPrimeUser = isPrimeStatus || isSubscriptionAdded;

                        return isPrimeUser && !isMultidestinationTrip(data) && !isDynpack &&
                            Odigeo._.includes(['BOOKING_CONFIRMED', 'BOOKING_PENDING'], data.bookingstatus);
                    },

                    shouldDoAutomaticRedirection: function(data) {
                        return this.shouldRedirectToMyTrips(data) || this.shouldRedirectToAccommodations(data);
                    },

                    onConfirmAccommodationPostBookingReady: function(confirmationData) {
                        // Re-enable logo link
                        $('#logo').removeClass('disabled');
                        Odigeo.requireWidget('confirmation-manager', 'confirmation_manager', function(confirmationmanager) {
                            confirmationmanager.execute('loadOnReady', confirmationData);
                        });
                        loadingPage.hideLoading();
                        $('.header_funnel_background').css({
                            height: '190px',
                        });
                        if (Odigeo._.includes(['BOOKING_CONFIRMED', 'BOOKING_RETAINED', 'BOOKING_PENDING'], confirmationData.bookingstatus)) {
                            tagManagement.updateDatalayer(confirmationData.tmsDatalayer);
                            this.trackEcommerceAndPageview(confirmationData.analyticsEcommerce);
                        }
                    },

                    onConfirmationError(status) {
                        confirmaHandlerResp.confirmationError(status, isDynpack);
                    },

                    isAutoCheckinProductBought() {
                        const shoppingCart = getStore().shoppingCart;
                        const postsellServiceOptionsItems = Odigeo._.get(shoppingCart,
                            'shoppingCart.otherProductsShoppingItems.postsellServiceOptionsItems') || [];
                        return postsellServiceOptionsItems.some((item)=>{
                            return item.name === 'AUTO_CHECKIN';
                        });
                    },

                    onConfirmationReady: async function(confirmationData) {
                        trackingUtils.counterMetric('FRONT' + appName + 'CONFIRMATION_READY_COUNTER');
                        eventCategory += confirmationData.bookingstatus.toLowerCase().substring(confirmationData.bookingstatus.indexOf('_'));
                        this.confirmationReadyTrackings(confirmationData);

                        let hasInitiatedRedirection = false;
                        if (this.shouldDoAutomaticRedirection(confirmationData)) {
                            hasInitiatedRedirection = await this.initiateAutomaticRedirection(confirmationData);
                        }

                        if (!hasInitiatedRedirection) {
                            Odigeo.requireWidget('confirmation-manager', 'confirmation_manager', function(confirmationmanager) {
                                confirmationmanager.execute('loadOnReady', confirmationData);
                            });
                        }


                        trackingUtils.trackEventIfCondition(eventCategory, 'unlocked', 'subscriber_included_booking',
                            !Odigeo._.isNull(confirmationData.membershipPerksDTO));

                        // Re-enable logo link
                        $('#logo').removeClass('disabled');

                        try {
                            Odigeo.Session.set('isAutoCheckinProductBought', this.isAutoCheckinProductBought(confirmationData));
                        } catch (err) {
                            logger.error(err, 'Error to verify if AUTO_CHECKIN product was bought');
                        }


                        if (confirmationData.bookingstatus === 'BOOKING_CONFIRMED') {
                            // TODO Save mytrip in LS. Add this to a proper site when real booking are done
                            const mytripsData = Odigeo.Utils.parseJson(Odigeo.Session.get('mytripsData')) || [];
                            if (!Odigeo._.isEmpty(confirmationData.myTrip)) {
                                mytripsData.push(confirmationData.myTrip);
                            }
                            Odigeo.Session.set('mytripsData', JSON.stringify(mytripsData));
                        }
                        $mainContainer.on(Odigeo.Events.tap, '.confirmation_cars_textlink_button', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            // Product should be one from {flights, hotels, dp} but there's still no hotels confirmation flow/page
                            let href = e.target.href;

                            Odigeo.requireWidget('google-analytics', 'googleanalytics', function(googleanalytics) {
                                href = googleanalytics.execute('prepareUrlToTrackCrossDomain', href);
                            });

                            trackingUtils.trackEventWithCategory(
                                (Odigeo.Utils.isRequestApp('dp') ? 'dynpack' : 'flights') + '_confirmation_page_confirmed',
                                'xsell_banner', 'cars_clicks_button');
                            window.open(href);
                        });

                        $mainContainer.on(Odigeo.Events.tap, '.confirmation_ground_transports_textlink_button', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            const href = e.target.href;
                            trackingUtils.trackEvent('xsell_banner', 'groundtransportation_clicks_button',
                                (Odigeo.Utils.isRequestApp('dp') ? 'dynpack' : 'flights') + '_confirmation_page_confirmed');
                            window.open(href);
                        });
                        if (Odigeo._.isFunction(window.usabilla_live)) {
                            window.usabilla_live('virtualPageView');
                        }
                    },

                    onUserInteractionNeeded: function(data) {
                        handler3DS.composePsd2Metric('3DS_TIME_ERROR', '_FLIGHTS_', 'startMetric');
                        handler3DS.composePsd2Metric('3DS_TIME', '_FLIGHTS_', 'startMetric');
                        confirmaHandlerResp.userInteractionNeededHandler(data);
                    },
                    onBookingNegativeFeeLoaded: function() {
                        Odigeo.requireWidget('payment-manager', 'paymentmanager', function(paymentmanager) {
                            paymentmanager.execute('showNegativeFee');
                        });
                        Odigeo._.delay(function() {
                            window.history.back();
                        }, Odigeo.ViewSwitcher.animationDuration * 2);
                    // Shit happened and you got scammed. Pay again bitch!
                    },
                    onBookingConfirmedLoaded: function() {
                        trackingUtils.counterMetric('FRONT' + appName + 'CONFIRMATION_CONFIRMED_COUNTER');

                        if (!Odigeo.AB.isNewNewsletterLogic) {
                            Odigeo.requireWidget('gdpr-newsletter', 'gdpr_newsletter', function(gdprNewslettermanager) {
                                gdprNewslettermanager.execute('suscribeToNewsletter');
                            });
                        }

                        if (Odigeo._.isFunction(window.usabilla_live)) {
                            window.usabilla_live('data', {
                                'custom': window.tc_vars,
                            });
                            window.usabilla_live('virtualPageView');
                        }

                        const $insuranceInConfirmation = $('#insurance-inconfirmation');
                        const trackInsuranceInConfirmation = function(e) {
                            e.stopPropagation();
                            e.preventDefault();

                            let $element = $(e.target);
                            $element = !$element.data('tracking') ? $element.closest('.insurance_inconfirmation') : $element;
                            trackingUtils.trackEvent('insurances_widget', $element.data('tracking'), Odigeo.History.getPageNameFromFragment());
                        };

                        this.helpers.showAdvertisementListGpt();

                        // Enhance serviceoptions hints
                        enhanceServiceOptionsDetailsList();

                        Odigeo.requireWidget('flight-details-confirmation', 'flight_details');


                        $insuranceInConfirmation.find('.insurance_inconfirmation').on(Odigeo.Events.tap, trackInsuranceInConfirmation);

                        $insuranceInConfirmation.find('.insurance_inconfirmation_form_trigger').on(Odigeo.Events.tap, function(e) {
                            trackInsuranceInConfirmation(e);
                            // submit form to redirect user to insurance provider site in a new tab
                            $('#confirmation').find('form[name="usaInsuranceForm"]').submit();
                        });
                    },

                    onBookingPaymentRetryLoaded: function(data) {
                        paymentButtonAttachment.retry = true;
                        confirmaHandlerResp.paymentRetryHandler(data, 'paymentRetry');

                        // Analytics: virtual page tracking
                        trackingUtils.trackPage('payment', {
                            funnel: true,
                            error: {type: 'default', message: 'retry'},
                        });
                        navigateToPayment({isSecured: true, replace: false});
                    },
                    onBookingRejectedLoaded: function() {
                        trackingUtils.counterMetric('FRONT' + appName + 'CONFIRMATION_REJECTED_COUNTER');
                        Odigeo.requireWidget('confirmation-manager', 'confirmation_manager', function(confirmationmanager) {
                            const buttonSearch = confirmationmanager.view.$cachedSelectors.confirmationContainer.find('.button_search');

                            buttonSearch.one(Odigeo.Events.tap, function() {
                                trackingUtils.trackEventWithCategory('flights_confirmation_page_rejected', 'reject_solutions', 'launch_new_search');
                                if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
                                    Odigeo.Utils.launchAccommodationPBSearch();
                                } else {
                                    Odigeo.Utils.goToApplicationHome(Odigeo.Utils.isRequestApp('dp'));
                                }
                            });
                        });
                        this.helpers.showAdvertisementListGpt();

                        // Analytics: virtual page tracking
                        trackingUtils.trackPage('confirmation', {
                            funnel: true,
                            error: {type: 'default', message: 'rejected'},
                            legacy: Odigeo.Utils.getFunnelTrackingLegacy() + 'rejected/',
                        });

                        // Analytics: event tracking
                        trackingUtils.trackEventWithCategory('flights_confirmation_page_rejected', 'booking_status', 'rejected_booking');
                        // Enhance serviceoptions hints
                        enhanceServiceOptionsDetailsList();
                    },
                    onCancelPayment: function() {
                        // Analytics: virtual page error tracking
                        trackingUtils.trackPage('payment', {
                            funnel: true,
                            error: {type: 'default', message: 'canceled'},
                        });
                        Odigeo.Router.navigate('payment');
                    },
                    onBuyFlightBtn: function() {
                        Odigeo.requireWidget('payment-manager', 'paymentmanager', function(paymentmanager) {
                            paymentmanager.execute('commit', false);
                        });
                    },
                    onBookingRepricingLoaded: function(data) {
                        confirmaHandlerResp.repricingHandlerDesktop(data, $priceBreakDownContainer);
                        widgetLoader.get('paymentButton').execute('setRepricing', Odigeo._.get(data, 'data', {}));
                        trackingUtils.trackPage('payment', {
                            funnel: true,
                            error: {type: 'default', message: 'repricing'},
                        });

                        Odigeo.Router.navigate('payment', {isSecured: true, replace: true});
                    },

                    cleaningDpWaitingPage: function() {
                        $mainContainer.removeClass('od-process-dpwaiting');
                    },

                    onDpToggleAccommodationDetails: function(settings) {
                        widgets.accommodationDetails().execute('process', settings);
                    },

                    onConfirmationPageSuccessfully: function() {
                        trackingUtils.stopMetric('LOAD_CONFIRM_DESKTOP');
                        this.hideWaitings();

                        trackingPageFlowUtils.launchAppearancesTracking({
                            trackingPageFlowAppearancesSettings: {
                                flow: 'payment_flow_appearances',
                                label: 'conf:OK',
                            },
                        });
                    },

                    onConfirmationPageUnsuccessfully: function() {
                        this.hideWaitings();

                        trackingPageFlowUtils.launchAppearancesTracking({
                            trackingPageFlowAppearancesSettings: {
                                flow: 'payment_flow_appearances',
                                label: 'conf:error',
                            },
                        });
                    },

                    hideWaitings: function() {
                        if (!isDynpack) {
                            Odigeo.UIElements.enhanceLoading($waitingPage).hideLoading();
                        } else {
                            this.enhancePopupCondition();
                            widgets.dpWaitingPage().execute('deactivate');
                            Odigeo.UIElements.enhanceLoading($waitingPage).hideLoading();
                        }

                        widgetLoader.get('paymentButton').execute('toggleButtons', false);
                    },

                    enhancePopupCondition: function() {
                        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(),
                            $mainContainer.find('.popup_confirmation_conditions_hint'), {
                                events: {
                                    tap: true,
                                },
                            });
                        $mainContainer.find('.conditions_section_title').on(Odigeo.Events.tap, Odigeo._.bind(this.showConditionsSection, this));
                    },

                    showConditionsSection: function(e) {
                        e.stopPropagation();
                        $mainContainer.find('div[class^="conditions_section_content_"]').addClass('hidden');
                        $mainContainer.find('.conditions_section_content_' + $(e.currentTarget).data('layer')).removeClass('hidden');
                    },
                    onHotelsSearchCompletedSuccessfully: function(data) {
                        asyncWidgets.getConfirmationManager().execute('loadHotelsBanner', data);
                    },
                    onHotelsSearchFailed: function(data) {
                        asyncWidgets.getConfirmationManager().execute('loadHotelsBannerNoResults', data);
                    },
                },
            });

        Odigeo.Router.eventController.execute();

        if (!Odigeo._.isEmpty(Odigeo.PageStorage.get('confirmation'))) {
            Odigeo.PageStorage.set('confirmation', true);
        }

        // the user is in the paypal/3ds/sofort page and returns to our site thought the browser back button
        // previous page was confirmation (flow is confirmation -> go out -> return to confirmation)
        // lastRoute is payment -> confirmation (isn't updated because we navigate with the browser buttons)

        const notConfirmationReached = Odigeo.Storage.get('confirmationReached') === 'false';
        if (lastPage === 'confirmation') {
            if (isFromPaymentToConfirmation) {
                if (notConfirmationReached) {
                    goBackToPayment();
                } else {
                    Odigeo.Session.set('confirmationReloaded', true);
                }
            }
            // user have reload the confirmation f5
            if (Odigeo.Session.get('confirmationReloaded') === 'true') {
                Odigeo.UIElements.showBookingAlreadyDone('alert');
            }
        }

        // the user is coming from payment but not through the continue button
        if (Odigeo._.isNull(Odigeo.Storage.get('fromContinueButton')) && isFromPaymentToConfirmation) {
            goBackToPayment();
        }
        trackingUtils.bindEvents($mainContainer);
        vinFlightsTracking.trackFlowOnLoad();
    };
}());
